import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import App from "./App";

const buttonStyle = {
  cursor: "pointer",
  color: "#0066ff",
  background: "none",
  border: "none",
  textDecoration: "underline",
  padding: 0,
};


const Auth = () => {
  const {
    isAuthenticated,
    isLoading,
    loginWithRedirect,
    logout,
    user,
  } = useAuth0();

  React.useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      loginWithRedirect(); // triggers login if not already authenticated
    }
  }, [isLoading, isAuthenticated, loginWithRedirect]);

  if (isLoading) {
    return (
      <div
        style={{
          position: "fixed",
          top: "0",
          left: "0",
          width: "100%",
          height: "100vh",
          backgroundColor: "rgba(0,0,0,0.5)",
          textAlign: "center",
          color: "white",
          paddingTop: "20vh",
          fontSize: "1.5rem",
        }}
      >
        Loading...
      </div>
    );
  }

  if (isAuthenticated && user && !user.email_verified) {
    return (
      <div
        style={{
          padding: "2rem",
          textAlign: "center",
          color: "#333",
          maxWidth: "600px",
          margin: "5rem auto",
          border: "1px solid #ccc",
          borderRadius: "8px",
        }}
      >
        <h2>Please verify your email address</h2>
        <p>
          Your email address is not verified yet. Please check your inbox and
          click the verification link we sent you.
        </p>
        <p>
  If you already verified your email,{" "}
  <button
    onClick={() => {
      logout({ returnTo: window.location.origin });
    }}
    style={buttonStyle}
  >
    click here to try logging in again
  </button>.
</p>

<p>
  Didn’t get the verifcation email? Trouble logging in or registering? Other questions?? Please{" "}
  <a href="https://www.quantqual.net/#contact" target="_blank" rel="noopener noreferrer" style={buttonStyle}>
    contact us here
  </a>{" "}
  and we’ll get in touch and help you out.
</p>
      </div>
    );
  }

  return isAuthenticated ? <App /> : null;
};

export default Auth;
